var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-text uk-text-center uk-margin-large-top uk-padding-small uk-padding-remove-horizontal footer"},[_vm._v(" © "+_vm._s(_vm.copyright)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }